import { Helmet } from 'react-helmet-async'

export default function SEO({
  title = 'Jesse B Tattoos | Bold Custom Tattoo Art',
  description = 'Jesse B Tattoos — bold, expressive, custom tattoo art. Book your session, explore the portfolio, and discover Tattoo Therapy services.',
  canonical,
  ogImage = 'https://jessebtattoos.com.au/og-image.jpg',
  noIndex = false,
}) {
  const siteUrl = 'https://jessebtattoos.com.au'

  const canonicalUrl = canonical
    ? canonical.startsWith('http')
      ? canonical
      : `${siteUrl}${canonical.startsWith('/') ? canonical : `/${canonical}`}`
    : siteUrl

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Jesse B Tattoos" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}